import { __makeTemplateObject } from "tslib";
import React from 'react';
import { Box, PinTL, PinTR } from '@marvelapp/ui';
import styled from 'styled-components';
function ModalButton(_a) {
    var position = _a.position, children = _a.children, onClick = _a.onClick;
    return (React.createElement(Position, { position: position },
        React.createElement(Button, { onClick: onClick }, children)));
}
function Position(_a) {
    var position = _a.position, children = _a.children;
    if (position === 'right') {
        return React.createElement(PinTR, null, children);
    }
    return React.createElement(PinTL, null, children);
}
var Button = styled(Box).attrs({
    margin: 3,
    fill: 'white',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background-color: rgba(31, 45, 61, 0.75); /* $black */\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background-color: rgba(31, 45, 61, 0.75); /* $black */\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
export default ModalButton;
var templateObject_1;
